import styled from 'styled-components';
import { Heading4Mixin } from '@qover/typography';

export const SummaryTermsSectionContainer = styled.div`
  background-color: ${({ theme }) => theme.colors.cardBackground()};
  border-radius: ${({ theme }) => theme.borders.cardRadius};
  border: 1px solid ${({ theme }) => theme.colors.primary()};
  color: ${({ theme }) => theme.colors.textQuote()};
  margin: 0 0 10px 0;
  padding: 40px;

  @media (max-width: ${props => props.theme.breakpoints.maxWidth.XS}) {
    padding: 20px;
  }

  h4 {
    ${Heading4Mixin};
    margin: 0;
  }

  > h4 + * {
    margin-top: 20px;
  }
`;

export const InnerContainer = styled.div`
  line-height: 1.54;

  a {
    font-weight: bold;
  }

  p:first-child {
    margin-top: 0;
  }

  p:last-child {
    margin-bottom: 0;
  }
`;

export const ActionContainer = styled.div`
  margin: 30px auto 0;
  max-width: 320px;

  button {
    width: 100%;
  }
`;
